<template>
  <div>
    <el-dialog
      :visible.sync="visibleSync"
      width="50%"
      :before-close="onClose"
    >
      <h1>
        {{$t('Flujos de aprobación de riesgos')}}
        <small>{{ workflow.name }}</small>
      </h1>
      <Workflow :workflow="workflow" :params="{'description_only': true}"></Workflow>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onClose">{{$t('Cerrar')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Workflow from '@/components/workflows/Workflow2.vue';

export default {
  props: ['onClose', 'visibleSync', 'workflow'],
  components: {
    Workflow,
  },
  created() {
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
